// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupCall__container-bbedd4 {
  background-color: var(--addition-80);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  overflow: hidden;
  flex-direction: column;
}

.GroupCall__call-content-adfb6b {
  position: relative;
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: calc(100% - 64px);
}

.GroupCall__center-content-cccae4 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.GroupCall__avatar-container-f90850 {
  margin-bottom: var(--indent-24px);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/GroupCall/GroupCall.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iCAAA;AACF","sourcesContent":[".container {\n  background-color: var(--addition-80);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  overflow: hidden;\n  flex-direction: column;\n}\n\n.call-content {\n  position: relative;\n  flex: 1 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-height: calc(100% - 64px);\n}\n\n.center-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.avatar-container {\n  margin-bottom: var(--indent-24px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GroupCall__container-bbedd4`,
	"call-content": `GroupCall__call-content-adfb6b`,
	"callContent": `GroupCall__call-content-adfb6b`,
	"center-content": `GroupCall__center-content-cccae4`,
	"centerContent": `GroupCall__center-content-cccae4`,
	"avatar-container": `GroupCall__avatar-container-f90850`,
	"avatarContainer": `GroupCall__avatar-container-f90850`
};
module.exports = ___CSS_LOADER_EXPORT___;
